import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-0a347c14"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
import { ref, reactive } from "vue";
import { requestHospitalsList } from "@/api";
import { debounce } from "@/utils";
import { Toast } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'hospitalPicker',
    props: {
        userType: {
            type: Number,
            default: 1,
        },
    },
    emits: ["cancel", "ok"],
    setup: function (__props, _a) {
        var _this = this;
        var emit = _a.emit;
        var props = __props;
        var value = ref("");
        var onSearch = function () {
            pageParams.pageIndex = 0;
            getHospitalsList();
        };
        var loading = ref(false);
        var finished = ref(false);
        var pageParams = reactive({
            pageIndex: 0,
            pageSize: 10,
        });
        var hospitalsList = ref([]);
        var getHospitalsList = function (salesman_id) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pageParams.pageIndex++;
                        return [4 /*yield*/, requestHospitalsList({
                                hospitalName: value.value,
                                pageIndex: pageParams.pageIndex,
                                pageSize: pageParams.pageSize,
                                salesman_id: salesman_id,
                            }).catch(function () {
                                finished.value = true;
                                Toast("系统错误-03");
                            })];
                    case 1:
                        res = _a.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            if (pageParams.pageIndex === 1) {
                                hospitalsList.value = [];
                            }
                            hospitalsList.value = hospitalsList.value.concat(res.data.records);
                            finished.value = res.data.pages <= pageParams.pageIndex;
                        }
                        else {
                            hospitalsList.value = [];
                            finished.value = true;
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var debounceGetHospitalsList = function (params) {
            return debounce(getHospitalsList(params), 300);
        };
        var onLoad = function () {
            loading.value = true;
            if (props.userType === 1) {
                debounceGetHospitalsList();
            }
            else {
                debounceGetHospitalsList(localStorage.getItem("userId"));
            }
        };
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_search = _resolveComponent("van-search");
            var _component_Form = _resolveComponent("Form");
            var _component_van_cell = _resolveComponent("van-cell");
            var _component_van_list = _resolveComponent("van-list");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "选择就诊医院",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (emit('cancel')); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_Form, null, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_van_search, {
                                modelValue: value.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((value).value = $event); }),
                                "show-action": "",
                                placeholder: "请输入搜索关键词",
                                onSearch: onSearch
                            }, {
                                action: _withCtx(function () { return [
                                    _createElementVNode("div", {
                                        style: { color: '#3DABA4' },
                                        onClick: onSearch
                                    }, "搜索")
                                ]; }),
                                _: 1
                            }, 8, ["modelValue"])
                        ]; }),
                        _: 1
                    }),
                    _createVNode(_component_van_list, {
                        style: _normalizeStyle({ marginTop: '0.16rem' }),
                        loading: loading.value,
                        "onUpdate:loading": _cache[2] || (_cache[2] = function ($event) { return ((loading).value = $event); }),
                        finished: finished.value,
                        "finished-text": "没有更多了",
                        onLoad: onLoad
                    }, {
                        default: _withCtx(function () { return [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hospitalsList.value, function (item) {
                                return (_openBlock(), _createBlock(_component_van_cell, {
                                    key: item.hospitalId,
                                    title: item.hospitalName,
                                    onClick: function ($event) { return (emit('ok', item.hospitalId, item.hospitalName)); }
                                }, null, 8, ["title", "onClick"]));
                            }), 128))
                        ]; }),
                        _: 1
                    }, 8, ["style", "loading", "finished"])
                ])
            ]));
        };
    }
});
